// extracted by mini-css-extract-plugin
export default {"TeamMemebers":"TeamMemebers_TeamMemebers__5dqut","TeamMemebersContainer":"TeamMemebers_TeamMemebersContainer__LjEzf","Title":"TeamMemebers_Title__peg2P"};